// @flow

import _throttle from 'lodash/throttle';
import Config from '@insolus/config';
import { observable, action } from 'mobx';

import type { Store } from '@insolus/stores';

class DevicesStore implements Store {
    @observable isMobile: boolean = false;
    @observable isTablet: boolean = false;
    @observable isSmallDesktop: boolean = false;

    init() {
        this._initSizesTracker();
    }

    _initSizesTracker() {
        if (typeof document === 'undefined') { return; }

        if (!['interactive', 'complet'].includes(document.readyState)) {
            document.addEventListener('DOMContentLoaded', () => {
                this._initSizesTracker();
            });
            return;
        }

        window.addEventListener('resize', this._retrieveSizesThrottled);
        this.retrieveSizes();
    }

    @action
    retrieveSizes: (() => void) = () => {
        if (typeof window === 'undefined') {
            this.isMobile = false;
            this.isTablet = false;
            return;
        }

        const width = window.innerWidth;
        this.isSmallDesktop = width <= Config.get('breakpoints.desktop');
        this.isTablet = width <= Config.get('breakpoints.small-desktop');
        this.isMobile = width <= Config.get('breakpoints.tablet');
    };

    _retrieveSizesThrottled = _throttle(this.retrieveSizes, 200);
}

export default (new DevicesStore(): DevicesStore);
export { DevicesStore };
